import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";
import axiosInstance from "../../../AxiosInstance/axiosInstance";

export const createDonateDetails = createAsyncThunk(
  "DonateDetails/createDonateDetails",
  async (donateDetailsData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/v1/admin/donate/create_donateDetails",
        donateDetailsData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDonateDetails = createAsyncThunk(
  "DonateDetails/getDonateDetails",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        "/v1/admin/donate/get_donateDetails",
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updateDonateDetails = createAsyncThunk(
  "Country/updateCountry",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/country/update-country/${id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteHelpLineNumber = createAsyncThunk(
  "Country/deleteCountry",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/country/delete-country/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteHelpLineNumber = createAsyncThunk(
  "Country/undoDeleteCountry",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/country/undodelete-country/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getHelpLineNumberById = createAsyncThunk(
  "Country/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/country/getSingle-country/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
